import * as coupons from '@wix/auto_sdk_marketing_coupons';
import * as marketingConsent from '@wix/auto_sdk_marketing_marketing-consent';
import * as adsTxt from '@wix/auto_sdk_marketing_ads-txt';

export { coupons, marketingConsent, adsTxt };
